import { UniTabHeader } from '@/design-system/components/tabs';
import { SxProp, View } from 'dripsy';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface BillPaymentConfirmationMobileProps {
  onClose: () => void;
}
export const BillPaymentConfirmationMobile: React.FC<BillPaymentConfirmationMobileProps> = (props) => {
  const { t } = useTranslation('global-bill-payment');

  return (
    <View sx={sxStyles.container}>
      <UniTabHeader title={t('global-bill-payment::glossary.title--border-less-payment')} onBack={props.onClose} />
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  container: {
    flex: 1,
    backgroundColor: '$backgroundPrimary'
  }
};
